var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifierQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5050",
    d: "M34.44 9.062a14.498 14.498 0 1 0 10.252 4.246A14.404 14.404 0 0 0 34.44 9.062Zm0-9.062C47.452 0 58 10.548 58 23.56c0 13.013-10.548 23.56-23.56 23.56-13.013 0-23.56-10.547-23.56-23.56C10.88 10.548 21.427 0 34.44 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5050",
    d: "m.789 50.145 11.293-11.293a2.72 2.72 0 0 1 1.925-.793h1.847l4.077 4.078v1.846a2.719 2.719 0 0 1-.793 1.925L7.846 57.203a2.708 2.708 0 0 1-3.84 0L.8 53.995a2.731 2.731 0 0 1-.011-3.851Z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5050",
    d: "M31.903 27.103v-4.497h2.403c.913 0 1.594-.24 2.042-.723.448-.5.672-1.103.672-1.81 0-.5-.104-.93-.31-1.292a2 2 0 0 0-.853-.878c-.362-.224-.801-.336-1.318-.336-.552 0-1.017.12-1.396.361a2.333 2.333 0 0 0-.879.905c-.206.38-.31.81-.31 1.292H28c0-1.137.25-2.162.75-3.075.516-.93 1.274-1.672 2.274-2.223 1-.551 2.205-.827 3.618-.827 1.31 0 2.438.25 3.386.75.947.482 1.68 1.154 2.197 2.015.517.862.775 1.853.775 2.973v.31c0 1.102-.267 2.076-.801 2.92-.517.827-1.275 1.482-2.274 1.964-1 .466-2.215.715-3.645.75l1.784-1.422-.052 2.843h-4.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5050",
    d: "M31.593 29.274v4.161h4.703v-4.16h-4.703Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierQuestion);
export default __webpack_public_path__ + "static/media/magnifier-question.34784372ec6e3a1a39ed61f4995ac8ce.svg";
export { ForwardRef as ReactComponent };